function SetDefaultValue(val, def) {
  val = val ? val : def;
  return val;
}

export { SetDefaultValue };
